import { Divider } from '#/components/Divider/Divider';
import { LoadingDots } from '#/components/LoadingDots/LoadingDots';
import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors } from '#/theme/theme';

import { ListingViewSidebarEventAttendees_Hide_1 } from './ListingViewSidebarEventAttendees.styled';

type Props = {
  loading?: boolean;
  count: number | undefined;
};

export function ListingViewSidebarEventAttendees({ loading, count }: Props) {
  const { i18n } = useI18n();

  return (
    <ListingViewSidebarEventAttendees_Hide_1>
      {loading && count === undefined && (
        <div style={{ position: 'relative', left: '12px' }}>
          <LoadingDots size="text" />
        </div>
      )}

      {count !== undefined && (
        <Text
          style={{ color: colors.lightContentGrey }}
          qaId="event-going-count"
        >
          {i18n('%(count)s Going', { count })}
        </Text>
      )}
      <Divider marginTop={24} marginBottom={24} />
    </ListingViewSidebarEventAttendees_Hide_1>
  );
}
